import { BindGoogleTokenOptionsV2 } from '../types';
import { createVerificationIntent } from '../utils/createVerificationIntent';

export const createGoogleTokenBindingApi2 = async (apiHost: string, params: BindGoogleTokenOptionsV2) => {
    return createVerificationIntent(apiHost, {
        ...params,
        flow: 'google-pay',
    });
};
